<template>
<!-- 更新情報入力画面 -->
<CCard>
  <CCardHeader>
    <h2>ユーザ更新</h2>
  </CCardHeader>
  <CCardBody>
    <p>*が付いている項目は必須入力項目です</p>
    <ValidationObserver ref="obs" v-slot="ObserverProps">
      <CRow v-if="message.length">
        <ul>
          <li style="color: red;" v-for="error in message" :key="error">{{ error }}</li>
        </ul>
      </CRow>
     <CRow>
       <CCol sm="3">
          <ValidationProvider name='社員番号' rules="employee|max:20" v-slot="ProviderProps">
            <CInput label="社員番号" v-model="items.employee_id"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='氏名' rules="required|name:20" v-slot="ProviderProps">
            <label>氏名<span class="asterisk">*</span></label>
            <CInput v-model="items.name" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='電話番号' rules="tel" v-slot="ProviderProps">
            <CInput label="電話番号" v-model="items.telephone" description="ハイフンなしで入力してください" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='住所' rules="address|max:60" v-slot="ProviderProps">
            <CInput label="住所" v-model="items.address" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='E-Mail' rules="required|email|max:254" v-slot="ProviderProps">
            <label>E-Mail<span class="asterisk">*</span></label>
            <CInput v-model="items.email" 
            @change="re_mail = ''"
            />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='E-Mail(確認)' rules="required|email|max:254|check:E-Mail" v-slot="ProviderProps">
            <label>E-Mail(確認)<span class="asterisk">*</span></label>
            <CInput v-model="re_mail"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <label>入社年月日</label>
          <CInput type="date" v-model="items.hire_date" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="4">
          <label>所属部署</label>
          <select class="custom-select" v-model="items.department_id">
            <option :value="0">未選択</option>
            <option
              v-for="option in departmentOptions"
              :value="option.id"
              :key="option.id"
            >
              {{ option.display_name || option.name }}
            </option>
          </select>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <label>ユーザ種別<span class="asterisk">*</span></label>
          <ValidationProvider rules="select" v-slot="ProviderProps">
            <select class="custom-select" v-model="items.authority_id">
              <option disabled value="">選択してください</option>
              <option v-for="option in options" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
      <CCol sm="3">
        <div class="d-flex align-items-center">
          <label class="custom-switch mb-0">
            <input
              type="checkbox"
              class="custom-switch-input"
              id="approver-flg-edit"
              v-model="items.approver_flg"
            />
            <span class="custom-switch-indicator" aria-hidden="true"></span>
          </label>
          <label for="approver-flg-edit" class="ml-2 mb-0">申請承認者</label>
        </div>
      </CCol>
      </CRow>
      <!-- 週稼働日数（有休付与区分） -->
      <CRow>
        <CCol sm="6">
          <label>週稼働日数（有休付与区分）</label>

          <div class="paid-grant-radio">
            <label
              class="btn btn-outline-info btn-sm paid-grant-btn"
              :class="{ active: items.working_days === 5 }"
              for="paidGrantNormalEdit"
            >
              <input
                type="radio"
                id="paidGrantNormalEdit"
                name="paidGrantRuleEdit"
                :value="5"
                v-model.number="items.working_days"
              />
              通常(週5日)
            </label>

            <label
              class="btn btn-outline-info btn-sm paid-grant-btn disabled"
              :class="{ active: items.working_days === 4 }"
              for="paidGrant4Edit"
              aria-disabled="true"
            >
              <input
                type="radio"
                id="paidGrant4Edit"
                name="paidGrantRuleEdit"
                :value="4"
                v-model.number="items.working_days"
                disabled
              />
              週4日
            </label>

            <label
              class="btn btn-outline-info btn-sm paid-grant-btn disabled"
              :class="{ active: items.working_days === 3 }"
              for="paidGrant3Edit"
              aria-disabled="true"
            >
              <input
                type="radio"
                id="paidGrant3Edit"
                name="paidGrantRuleEdit"
                :value="3"
                v-model.number="items.working_days"
                disabled
              />
              週3日
            </label>

            <label
              class="btn btn-outline-info btn-sm paid-grant-btn disabled"
              :class="{ active: items.working_days === 2 }"
              for="paidGrant2Edit"
              aria-disabled="true"
            >
              <input
                type="radio"
                id="paidGrant2Edit"
                name="paidGrantRuleEdit"
                :value="2"
                v-model.number="items.working_days"
                disabled
              />
              週2日
            </label>

            <label
              class="btn btn-outline-info btn-sm paid-grant-btn disabled"
              :class="{ active: items.working_days === 1 }"
              for="paidGrant1Edit"
              aria-disabled="true"
            >
              <input
                type="radio"
                id="paidGrant1Edit"
                name="paidGrantRuleEdit"
                :value="1"
                v-model.number="items.working_days"
                disabled
              />
              週1日
            </label>

            <label
              class="btn btn-outline-secondary btn-sm paid-grant-btn"
              :class="{ active: items.working_days === 0 }"
              for="paidGrantNoneEdit"
            >
              <input
                type="radio"
                id="paidGrantNoneEdit"
                name="paidGrantRuleEdit"
                :value="0"
                v-model.number="items.working_days"
              />
              有休付与無し
            </label>
          </div>

          <div class="text-muted small mt-1">
            ※「4日/3日/2日/1日」は現在未実装のため選択できません。
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>有給日数</label>
          <ValidationProvider name='有給日数' rules="holiday|min:-99.9|max:99.9" v-slot="ProviderProps">
            <CInput v-model="items.paid_days" placeholder="10.0" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>代休日数</label>
          <ValidationProvider name='代休日数' rules="holiday|min:-99.9|max:99.9" v-slot="ProviderProps">
            <CInput v-model="items.comp_days" placeholder="10.0" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>今期有休消化日数</label>
          <ValidationProvider name='今期有休消化日数' rules="holiday|min:-99.9|max:99.9" v-slot="ProviderProps">
            <CInput v-model="items.paid_days_used" placeholder="10.0" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>有給付与月</label>
          <ValidationProvider name='有給付与月' rules="holiday|min:-99.9|max:99.9" v-slot="ProviderProps">
            <CInput v-model="items.paid_days_add" placeholder="10.0" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>固定内残業</label>
          <ValidationProvider name='固定内残業' rules="total_time" v-slot="ProviderProps">
            <CInput v-model="items.fixed_over_time" placeholder="00:00" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>Slack ID</label>
          <ValidationProvider name='Slack ID' rules="max:20" v-slot="ProviderProps">
            <CInput v-model="items.slack_id" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <br>
      <CRow class="mt-3 align-items-center">
        <!-- 左寄せ：戻る -->
        <CCol class="text-start">
          <button class="btn btn-secondary" @click="valueCheck">戻る</button>
        </CCol>
        <!-- 横並び：確認 -->
        <CCol class="text-center">
          <button v-on:click="openModal" class="btn btn-info" :disabled="ObserverProps.invalid">確認</button>
          <!-- 更新確認モーダルコンポーネント呼出 -->
          <!--isHolidayField モーダル呼出時判定の受け渡し-->
          <UpdateModal 
            :draggable="true" 
            :resizable="true" 
            :employee="items.employee_id" 
            :user="items.name" 
            :tel="items.telephone" 
            :live="items.address" 
            :mail="items.email" 
            :hire_date="items.hire_date"
            :department_name="selectedDepartmentLabel()"
            :select="items.authority_id_name" 
            :approver_flg="items.approver_flg" 
            :working_days="items.working_days"
            :paid="items.paid_days" 
            :comp="items.comp_days" 
            :paid_used="items.paid_days_used" 
            :paid_add="items.paid_days_add" 
            :fixed_over_time="items.fixed_over_time" 
            :slack_id="items.slack_id"
            :loading="loading"
            :isHolidayFields="isHolidayFields"
            v-show="showModal"
            @update="update" 
            @close="closeModal">
          </UpdateModal>
        </CCol>
        <!-- 空白スペース用 -->
        <CCol ></CCol>
      </CRow>
    </ValidationObserver>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import UpdateModal from './UpdateModal'
import axios from 'axios'
export default {
  name: 'UpdateInput',
  components: {
    UpdateModal
  },
  data() {
    return {
      showModal: false,
      authority_id: '',
      employee_id: '',
      name: '',
      telephone: '',
      address: '',
      email: '',
      re_mail: '',
      hire_date: '',
      paid_days:0,
      comp_days:0,
      paid_days_used:0,
      paid_days_add:0,
      department_id: '',
      department_name: '',
      fixed_over_time:'',
      slack_id: '',
      departmentOptions: [],
      options: [],
      authority_id_name: '',
      approver_flg: false,
      items: [],
      check: [],
      message: [],
      id: '',
      loading: false,
      isHolidayFields:true   //注釈表示制御定義
    }
  },
  methods: {
    // ユーザ詳細へ遷移する際の入力値チェック
    valueCheck: function () {
      if (confirm(ConstList.TRANSITION)) {
        this.$router.push({
          name: ConstList.ROUTE_INFO,
          params: {
            id: this.$route.params.id
          }
        })
      }
    },
    // モーダルを表示
    openModal: function () {
      const userType = this.options.find(({id}) => id === this.items.authority_id);
      this.items.authority_id_name = userType.name
      this.showModal = true
      this.isHolidayFields = this.items.isHolidayFields === true    //注釈表示制御
    },
    // 更新情報を送信
    update: function () {
      this.loading = true;
      const params = new URLSearchParams()
      params.append(ConstList.EMPLOYEE_ID, this.items.employee_id)
      params.append(ConstList.NAME, this.items.name)
      params.append(ConstList.ADDRESS, this.items.address || '')
      params.append(ConstList.TELEPHONE, this.items.telephone || '')
      params.append(ConstList.EMAIL, this.items.email)
      params.append(ConstList.HIRE_DATE, this.items.hire_date || '')
      params.append(ConstList.AUTHORITY_ID, this.items.authority_id)
      const departmentId = (this.items.department_id === '' || this.items.department_id == null)
        ? 0
        : Number(this.items.department_id)
      params.append(ConstList.DEPARTMENT_ID, departmentId)
      params.append(ConstList.APPROVER_FLG, this.items.approver_flg)
      params.append(ConstList.PAID_DAYS, Number(this.items.paid_days))
      params.append(ConstList.COMP_DAYS, Number(this.items.comp_days))
      params.append(ConstList.PAID_DAYS_USED, Number(this.items.paid_days_used))
      params.append(ConstList.PAID_DAYS_ADD, Number(this.items.paid_days_add))
      params.append(ConstList.WORKING_DAYS, Number(this.items.working_days))
      params.append(ConstList.FIXED_OVER_TIME, this.items.fixed_over_time)
      params.append(ConstList.SLACK_ID, this.items.slack_id)
      this.id = this.$route.params.id
      const id = parseInt(this.id);
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/users/' + id , params)
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            alert(ConstList.REGISTER_MESSAGE)
            this.showModal = false
            this.$router.push({ 
              name: ConstList.ROUTE_LIST
          });
          } else {
            this.message[0] = response.data
            this.showModal = false
            location.hash = ConstList.UPDATE_TOP
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },
    selectedDepartmentLabel: function () {
      if (!this.items || this.items.department_id == null || this.items.department_id === '') {
        return ''
      }

      const dept = this.departmentOptions.find(({ id }) => String(id) === String(this.items.department_id))
      if (dept) {
        return dept.display_name || dept.name
      }

      return this.items.department_name || '（現在無効）'
    },

    mergeCurrentDepartmentOption: function () {
      if (!this.items || this.items.department_id == null || this.items.department_id === '') {
        return
      }

      const exists = this.departmentOptions.some(({ id }) => String(id) === String(this.items.department_id))
      if (exists) {
        return
      }

      let label = this.items.department_name || ''
      if (label && label.indexOf('（現在無効）') === -1) {
        label = label + '（現在無効）'
      }
      if (!label) {
        label = '（現在無効）'
      }

      this.departmentOptions.push({
        id: this.items.department_id,
        name: this.items.department_name || '',
        display_name: label
      })
    },

    fetchDepartmentOptions: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/departments/count')
        .then((countResponse) => {
          const totalCount = Number(countResponse.data)
          const allCount = Number.isFinite(totalCount) && totalCount > 0 ? totalCount : 1

          return axios.get(process.env.VUE_APP_API_ORIGIN + '/departments', {
            params: {
              currentPage: 1,
              pageSize: allCount
            }
          })
        })
        .then((response) => {
          const list = Array.isArray(response.data) ? response.data : []
          this.departmentOptions = list
            .filter((item) => Number(item.deleted_flg) !== ConstList.DELETE)
            .map((item) => ({
              id: item.id,
              name: item.name
            }))

          this.mergeCurrentDepartmentOption()
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            })
        })
    }
  },
    // 詳細画面から各種情報を取得
  mounted: function () {
      this.id = this.$route.params.id
      const id = parseInt(this.id);
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/users/' + id)
        .then(response => {
          this.items = response.data
          this.re_mail = this.items.email;
          if (this.items.length === 0) {
            this.errors.push(ConstList.EMPTY)
          }
          this.fetchDepartmentOptions();
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(()=> {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/users/authority')
        .then(response => {
          this.options = response.data
          if (response.data.length === 0) {
            this.errors.push(ConstList.EMPTY)
          }
                    })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
  },
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

</style>
